module.exports = __webpack_public_path__ + "static/media/jail.44ef82d8.PNG";